import React from 'react';

import { useDispatch } from 'react-redux';

import { IconButton } from '@atlaskit/button/new';
import SettingsIcon from '@atlaskit/icon/glyph/settings';

import { useIntl } from 'src/hooks/intl';
import { toggleSettingsDialog } from 'src/redux/diff-settings';

import { useDiffSettingsButtonAnalytics } from '../../../hooks/analytics';
import messages from '../../diff-settings/i18n';

interface DiffSettingsButtonProps {
  tabIndex?: number;
  appearance?: 'default' | 'subtle';
}

export const DiffSettingsButton = React.memo(
  ({ tabIndex = 0, appearance = 'default' }: DiffSettingsButtonProps) => {
    const dispatch = useDispatch();
    const intl = useIntl();
    const publishDiffAnalytics = useDiffSettingsButtonAnalytics();

    const handleClick = () => {
      publishDiffAnalytics();
      dispatch(toggleSettingsDialog(true));
    };

    return (
      <IconButton
        appearance={appearance}
        icon={SettingsIcon}
        onClick={handleClick}
        label={intl.formatMessage(messages.diffSettingsButtonLabel)}
        tabIndex={tabIndex}
      />
    );
  }
);
